<template>
  <a-config-provider :locale="zhCN">
    <div id="app">
      <router-view/>
    </div>
  </a-config-provider>
</template>
<script>
import { removeToken } from '@/utils/auth'
import ConfigProvider from 'ant-design-vue/es/config-provider' // ant-design 组件 全局使用中文
import zhCN from 'ant-design-vue/es/locale-provider/zh_CN' // ant-design 组件 全局使用中文

export default {
  name: 'App',
  data () {
    return {
      zhCN,
    }
  },
  methods: {},
  created () {
    //在页面加载时读取sessionStorage里的状态信息
    if (localStorage.getItem('user')) {
      //this.$store.replaceState(Object.assign({}, this.$store.state.user,JSON.parse(sessionStorage.getItem("user"))))
      this.$store.commit('user/SET_USER_FROM_STORAGE', JSON.parse(localStorage.getItem('user')))
    }
  }
}
</script>
<style>
html, body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow-y: hidden;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000000;
  width: 100%;
  height: 100%;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

@media (max-width: 720px) {
  .msgBox {
    width: 320px !important;
  }
}
</style>
